var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zg-module',_vm._b({},'zg-module',_vm.moduleProps,false),[_c('zg-reviewed-by',_vm._b({attrs:{"background":(_vm.backgroundSettings && _vm.backgroundSettings.backgroundColor) || 'white'},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},'zg-reviewed-by',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }